import { useState, useEffect, useCallback, useMemo } from "react";
import configData from "../config";
import { axiosSetting } from "../libs/utils";

const DEFAULTS = {
  logo: "https://myprotectall.com/wp-content/uploads/2023/09/PA-Logo-Horizonal-Blue.png",
  brandVideoUrl:
    "https://gbspublicassets.s3.amazonaws.com/wp_site_videos/Fabric_Leather_and_Wood_Accidents_Weve_got_you_covered_1080p.mp4",
  backgroundImage: "/image/banner-1.jpg",
};

const useSecretConfig = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const subdomain = window.location.host.split(".")[0];
  const axiosCall = useMemo(() => axiosSetting(null), []);

  const fetchSecret = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axiosCall.get(
        `${configData.getSecret}/mpos-${subdomain}`
      );
      const fetchedData = response.data?.data || {};
      const theme = fetchedData.theme || {};

      const finalData = {
        ...fetchedData,
        theme: {
          ...theme,
          logo: theme.logo || DEFAULTS.logo,
          brandVideoUrl: theme?.brandVideoUrl,
          backgroundImage: theme.backgroundImage,
        },
      };
      setData(finalData);
      setError(null);
    } catch (err) {
      setError(err.message || "Failed to fetch secret data");
    } finally {
      setLoading(false);
    }
  }, [axiosCall, subdomain]);

  useEffect(() => {
    fetchSecret();
  }, [fetchSecret]);

  return { data, loading, error };
};

export default useSecretConfig;
